import {useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Anticipation.css";

const Anticipation = () => {

  const navigate = useNavigate();
  
   const [hasAccess, setHasAccess] = useState(null);
  
    useEffect(() => {
  
      const email = localStorage.getItem("user_email");
  
      if (!email) {
        navigate("/");
        return;
      }
  
      axios
        .get(`/check-access?email=${email}&test=working_memory`)
        .then(res => {
  
          console.log("API:", res.data); // 👈 debug
  
          if (res.data.allowed) {
            setHasAccess(true);
          } else {
            setHasAccess(false);
          }
  
        })
        .catch(() => navigate("/"));
  
    }, []);
  
    // 🔥 THIS PART IS VERY IMPORTANT
  
    if (hasAccess === null) {
      return <div>Loading...</div>;
    }
  
    if (hasAccess === false) {
      return (
        <div className="access-denied-container">
          <h2>🚫 Access Denied</h2>
          <p>You don’t have access to this test</p>
          <button onClick={() => navigate("/")}>Go Back</button>
        </div>
      );
    }
    

  return (
    <div className="rg-login-wrapper">

      {/* ================= HEADER SECTION ================= */}
      <div className="reaction-header-card">

        <h2 className="reaction-title">Anticipation Test</h2>

        <p className="reaction-subtitle">
          Anticipation measures your ability to 
          <strong> predict what will happen next </strong>
          based on visual cues and movement patterns.
          It trains the brain to 
          <strong> “Observe → Predict → React.”</strong>
        </p>

        <div className="reaction-pill">
          Test type: <strong>Prediction → Decision making</strong>
        </div>

        <hr className="reaction-divider" />

        {/* ================= WHY SECTION ================= */}
        <div className="reaction-why-card">

          <h3 className="why-title">
            Why anticipation matters in sport
          </h3>

          <p className="why-description">
            In sports, elite athletes don’t just react — they anticipate.
            Whether it’s predicting a pass, reading an opponent’s move,
            or timing a shot, anticipation gives players a critical
            advantage by reducing reaction time and improving decisions.
          </p>

          <div className="why-tags">
            <span>Faster decision making</span>
            <span>Better game intelligence</span>
            <span>Improved reaction timing</span>
            <span>Predict opponent movement</span>
            <span>Enhanced performance under pressure</span>
          </div>

        </div>
      </div>

      {/* ================= HOW GAME WORKS ================= */}
      <div className="how-card">

        <h2 className="how-title">How the game works</h2>

        <ul className="how-list">
          <li>
            A moving object or pattern will appear on the screen.
          </li>
          <li>
            It may disappear or change direction suddenly.
          </li>
          <li>
            Your task is to <strong>predict where it will appear next</strong>.
          </li>
          <li>
            Select or click the correct predicted position.
          </li>
          <li>
            You will get <strong>multiple rounds</strong> and your accuracy and timing will be recorded.
          </li>
          <li>
            Faster and correct predictions increase your score.
          </li>
        </ul>

        <p className="how-note">
          Tip: Focus on movement patterns instead of reacting randomly.
        </p>

      </div>

      {/* ================= START TEST ================= */}
      <div className="start-test-section">

        <h2>Ready to test your anticipation skills?</h2>

        <button
          className="start-test-btn"
          onClick={() => navigate("/anticipation/play")}
        >
          Start Test
        </button>

      </div>

    </div>
  );
};

export default Anticipation;